export class Apikeys {
  nombreFantasia: string;
  web: string;
  ruc: string;
  email: string;
  apiKeyProduction: string;
  apiKeyTest: string;
  urlProduction: string;
  urlTest: string;
  publicKeyProduction: string;
  publicKeyTest: string;
  codigo: string;


  constructor(nombreFantasia?: string, web?: string, ruc?: string, email?: string, apiKeyProduction?: string, apiKeyTest?: string, urlProduction?: string, urlTest?: string, publicKeyProduction?: string, publicKeyTest?: string, codigo?: string) {
    this.nombreFantasia = nombreFantasia ?? '';
    this.web = web ?? '';
    this.ruc = ruc ?? '';
    this.email = email ?? '';
    this.apiKeyProduction = apiKeyProduction ?? '';
    this.apiKeyTest = apiKeyTest ?? '';
    this.urlProduction = urlProduction ?? '';
    this.urlTest = urlTest ?? '';
    this.publicKeyProduction = publicKeyProduction ?? '';
    this.publicKeyTest = publicKeyTest ?? '';
    this.codigo = codigo ?? '';
  }
}
